import { normaliseGbPostcode } from '../../supabase/functions/_shared/postcode'

export type PostcodeLocation = { postcode: string; latitude: number; longitude: number }
const locations = new Map<string, PostcodeLocation>()
const unavailable = 'A map location is not available for this postcode.'

// This cache lasts only for the current admin page/session; no customer data is persisted.
export async function lookupPostcodeLocation(value: string, signal: AbortSignal): Promise<PostcodeLocation> {
  const postcode = normaliseGbPostcode(value).postcode
  signal.throwIfAborted()
  const cached = locations.get(postcode)
  if (cached) return cached
  const response = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(postcode.replaceAll(' ', ''))}`, {
    signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]), credentials: 'omit',
  })
  if (response.status === 404) throw new Error(unavailable)
  if (!response.ok) throw new Error('The location service could not be reached. Please try again.')
  const body = await response.json()
  const result = body?.result
  if (body?.status !== 200 || !result || typeof result.postcode !== 'string'
    || normaliseGbPostcode(result.postcode).postcode !== postcode
    || typeof result.latitude !== 'number' || !Number.isFinite(result.latitude) || Math.abs(result.latitude) > 90
    || typeof result.longitude !== 'number' || !Number.isFinite(result.longitude) || Math.abs(result.longitude) > 180) throw new Error(unavailable)
  signal.throwIfAborted()
  const location = { postcode, latitude: result.latitude, longitude: result.longitude }
  // Bound memory when staff browse a large number of postcode groups.
  if (locations.size >= 100) locations.delete(locations.keys().next().value!)
  locations.set(postcode, location)
  return location
}
